import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import { API_URLS, emptyString } from "../constants";

const { GROUP, BRAND } = API_URLS;

//Function to get paginated Groups Against Brand ID
const getGroupsByBrandId = (
  { search = emptyString, from = 0, take = 15 },
  brandId
) => {
  return getRequest(
    `${GROUP.BASE}/${brandId}/?search=${encodeURIComponent(search)}&from=${from}&take=${take}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to Delete group by ID
const deleteGroup = (groupId) => {
  return deleteRequest(`${GROUP.BASE}/${groupId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to create group
const addGroup = (body) => {
  return postRequest(GROUP.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to get groups against brand ID
const getGroups = (brandId) => {
  return getRequest(`${GROUP.GET}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to remove brand location by BrandLocationID
const removeBrandLocation = (brandLocationId) => {
  return putRequest(`${GROUP.REMOVE_LOCATION}/${brandLocationId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting brand by brandID
const getLocationByBrandId = (brandId) => {
  return getRequest(`${BRAND.GET_LOCATION_BY_BRAND_ID}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to update group
const updateGroupDetails = (body) => {
  return putRequest(GROUP.UPDATE_GROUP, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Update Brand Status
const updateGroup = (
  id,
  { search = emptyString, filter = emptyString, from = 0, take = 15 }
) =>
  putRequest(
    `${GROUP.UPDATE_GROUP_STATUS}/${id}?search=${search}&filter=${filter}&from=${from}&take=${take}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

//Exporting functions for other files
export const groupsService = {
  getGroupsByBrandId,
  deleteGroup,
  addGroup,
  getGroups,
  removeBrandLocation,
  getLocationByBrandId,
  updateGroup,
  updateGroupDetails,
};
